import { restClient } from '@/Core'

/**
 * Soft-deletes own message (204): the backend keeps the row, clears the
 * content and sets isDeleted, so the feed shows a stub instead of a gap.
 */
export const DeleteMessageTask = async (messageId: string): Promise<void> => {
    await restClient.delete(`/services/chat/messages/${messageId}`)
}
